/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Lock_TextInputs */

const en_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Do you want to lock "${i?.name}"? This will prevent others from modifying it.`)
};

const fr_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous verrouiller "${i?.name}" ? Cela empechera les autres de le modifier.`)
};

const de_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" sperren? Dadurch wird verhindert, dass andere es verändern.`)
};

const it_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuoi bloccare "${i?.name}"? Questo impedirà ad altri di modificarlo.`)
};

const ru_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы хотите заблокировать "${i?.name}"? Это предотвратит его изменение другими пользователями.`)
};

const es_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Quieres bloquear "${i?.name}"? Esto impedirá que otros lo modifiquen.`)
};

const zh_cn2_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`是否要锁定“${i?.name}”？这将防止其他人对其进行修改。`)
};

const ja_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」をロックしますか？ロックすると、他のユーザーが変更できなくなります。`)
};

const hi_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप "${i?.name}" को लॉक करना चाहते हैं? इससे दूसरों को इसे संशोधित करने से रोका जा सकेगा।`)
};

const pt_pt2_explorer_info_lock_text = /** @type {(inputs: Explorer_Info_Lock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deseja bloquear "${i?.name}"? Isso impedirá que outros o modifiquem.`)
};

/**
* | output |
* | --- |
* | "Do you want to lock \"{name}\"? This will prevent others from modifying it." |
*
* @param {Explorer_Info_Lock_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_lock_text = /** @type {((inputs: Explorer_Info_Lock_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Lock_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_lock_text(inputs)
	if (locale === "de") return de_explorer_info_lock_text(inputs)
	if (locale === "it") return it_explorer_info_lock_text(inputs)
	if (locale === "ru") return ru_explorer_info_lock_text(inputs)
	if (locale === "es") return es_explorer_info_lock_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_lock_text(inputs)
	if (locale === "ja") return ja_explorer_info_lock_text(inputs)
	if (locale === "hi") return hi_explorer_info_lock_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_lock_text(inputs)
	return en_explorer_info_lock_text(inputs)
});